import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITravelPurposeDetails } from "../travelpurposeModel";

export const getAllTravelPurpose = createAsyncThunk(
  "TravelPurpose/FindAllTravelPurpose",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/FindAllTravelPurpose`,
        {
          TravelPurpose: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTravelPurposeByID = createAsyncThunk(
  "TravelPurpose/FindByIDTravelPurpose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/FindByIDTravelPurpose`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        TravelPurpose: result?.TravelPurpose,
        IsActive: result?.IsActive ? 1 : 2,
      } as ITravelPurposeDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTravelPurposes = createAsyncThunk(
  "TravelPurpose/FindAllActiveTravelPurpose",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/TravelPurpose/FindAllActiveTravelPurpose`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTravelPurpose = createAsyncThunk(
  "TravelPurpose/InsertTravelPurpose",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/InsertTravelPurpose`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTravelPurpose = createAsyncThunk(
  "TravelPurpose/UpdateTravelPurpose",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/UpdateTravelPurpose`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const travelPurposeActiveInactive = createAsyncThunk(
  "TravelPurpose/ActiveInActiveTravelPurpose",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/ActiveInActiveTravelPurpose`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTravelPurpose = createAsyncThunk(
  "TravelPurpose/DeleteTravelPurpose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelPurpose/DeleteTravelPurpose`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting TravelPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
